import React, { useContext, useEffect, useRef, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import Switch from 'react-switch';

import InputField from 'components/Form/InputField';
import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import { ButtonContainer, ButtonMiradorOrange, ButtonMiradorWhite } from 'components/Button';
import Loader from 'components/Loader';

import FitFormTolls from 'utils/src/fitinsur-form-tolls';
import Mask from 'utils/src/mask';
import { FitinsurAPI, MessageCenter } from 'utils';
import Colors from 'constants/Colors';
import { GlobalAuthContext, GlobalLoaderContext, GlobalOperationContext } from 'store/context';
import { BorderSwitch, ButtonContent, ErrorMessage } from './styles';

export default function Page11({ match }) {

  const [validations, setValidations] = useState({});
  const [questions, setQuestions] = useState([]);
  const [currentPlan, setCurrentPlan] = useState({});

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const operationContext = useContext(GlobalOperationContext);
  const fitform = new FitFormTolls();
  const history = useHistory();
  const { idOperation } = match.params;
  const formikRef = useRef(Formik);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const initial = {
    "187": '',
    "192": '',
    "188": '',
    "189": '',
    "194": '',
    "197": '',
    "198": '',
    "235": false,
  };
  const fieldQuestions = {
    CPF: "187",
    Pep: "192",
    email: "188",
    name: "189",
    mntContribution: "194",
    paymentMth: "197",
    paymentDate: "198",
    authorizeCharge: "235"
  }

  const goToPage12 = (body) => {
    history.push('/embed/page12');
  };

  let messageHeader = () => {
    return (
      <><div style={{ width: "100%", height: "100%", background: "linear-gradient(270deg, rgba(251,160,52,1) 20%, rgba(199,115,4,1) 50%)" }}>
        <h4 style={{ fontWeight: "bold", marginTop: "10px", color: `${Colors.WHITE}` }}>
          Parabéns!
          <br />
          Agora, só confirma, abaixo,
          <br />
          os dados de quem será o titular do plano.
        </h4>
      </div>
      </>
    );
  }

  const getInitialValues = async () => {

    const auxQuestions = [
      ...operationContext.add_response.operationQuestionnaire,
      ...operationContext.add_response.personQuestionnaire,
      ...operationContext.add_response.riskQuestionnaire,
      ...operationContext.add_response.formPaymentQuestionnaire,
    ]
    setQuestions(auxQuestions);

    const cpf = operationContext.add2_request.personQuestionnaire.find(qst => qst.idQuestion == fieldQuestions.CPF);
    formikRef.current.setFieldValue(fieldQuestions.CPF, Mask.cpf(cpf.textQuestionAnswer));

    const name = operationContext.add2_request.personQuestionnaire.find(qst => qst.idQuestion == fieldQuestions.name);
    formikRef.current.setFieldValue(fieldQuestions.name, name.textQuestionAnswer);

    const mntCont = operationContext.add2_request.riskQuestionnaire.find(qst => qst.idQuestion == fieldQuestions.mntContribution);
    formikRef.current.setFieldValue(fieldQuestions.mntContribution, String(mntCont.textQuestionAnswer));

    const email = operationContext.add2_request.personQuestionnaire.find(qst => qst.idQuestion == fieldQuestions.email);
    formikRef.current.setFieldValue(fieldQuestions.email, String(email.textQuestionAnswer));

    // Obtendo as informações do plano
    const resultPlan = operationContext.add2_response[6]; // 6 Planos
    const resultCoverage = operationContext.add2_response[7]; // 7 Coberturas
    const acceptResultFinal = operationContext.add2_response[5].acceptResultFinal; // 5 resultdado

    if (resultPlan && resultPlan.length > 0 && Boolean(acceptResultFinal) === Boolean(true)) {
      resultPlan.forEach((plan) => {
        // recupera valores dos items resultCoverage[].coverageCalc[].coverageItems[];
        const idProductPlan = plan.id_product_plan;
        let coverages = [], faturamin, limiteCobertura;

        // Capturando o idProductCoverage da primeira cobertura do array para recuperar o valor da fatura min mensal
        const idProductCoverage = resultCoverage[0].coverageCalc[0].coverageItems[0].idProductCoverage;
        faturamin = plan.calculation.formulaResultList.find(el => el.formulaIdProductCoverage === idProductCoverage && el.formulaName === "premioMinimoSeguroMensal").formulaExpressionResult;
        console.log("ID Plano atual ->: ", idProductPlan);
        console.log("Planos ->: ", resultPlan);
        console.log("fatura minima mensal ->: ", faturamin);

        resultCoverage.forEach((element) => {
          if (element.id_product_plan == idProductPlan && element.coverageCalc) {
            element.coverageCalc.forEach((elementCalc) => {
              if (elementCalc.coverageItems) {
                elementCalc.coverageItems.forEach((item) => {

                  const formulaTaxaCobertura = plan.calculation.formulaResultList.find(el => el.formulaIdProductCoverage === item.idProductCoverage && el.formulaName === "descricaoTaxaCobertura");
                  const descricaoTaxaCobertura = (formulaTaxaCobertura ? formulaTaxaCobertura.formulaExpressionResult : "");

                  limiteCobertura = plan.calculation.formulaResultList.find(el => el.formulaIdProductCoverage === item.idProductCoverage && el.formulaName === "limiteCobertura").formulaExpressionResult;

                  if (!limiteCobertura) {
                    const resultLim = plan.calculation.formulaResultList.find(el => el.formulaIdProductCoverage === item.idProductCoverage && el.formulaName === "limiteCoberturaDefault");
                    limiteCobertura = resultLim.formulaExpressionResult;
                  };

                  /* API não retorna premioMinimoSeguroMensalDefault
                     if (!faturamin) {
                      const resultFatmin = plan.calculation.formulaResultList.find(el => el.formulaIdProductCoverage === item.idProductCoverage && el.formulaName === "premioMinimoSeguroMensalDefault");
                      faturamin = resultFatmin.formulaExpressionResult;
                      console.log("Result Fatmin: ", resultFatmin);
                    }; 
                  */

                  coverages.push({
                    coverageName: item.coverageName,
                    coverageLimit: Mask.currency({
                      value: limiteCobertura,
                      lang: "pt-br",
                      currency: 'BRL',
                      style: 'currency'
                    }),
                    coveragePremium: Mask.currency({
                      value: item.coveragePremium,
                      lang: "pt-br",
                      currency: 'BRL',
                      style: 'currency'
                    }),
                    coverageDeductible: item.deductibleDescription,
                    coverageTax: descricaoTaxaCobertura
                  });
                });
              }
            })
          }
        });

        let resultItem = {
          productPlanName: plan.product_plan_name,
          idProductPlan: idProductPlan,
          id_operation: plan.id_operation,
          id_Product: plan.id_product,
          coverages: coverages,
          limiteCobertura: Mask.currency({
            value: limiteCobertura,
            lang: "pt-br",
            currency: 'BRL',
            style: 'currency'
          }),
          faturamin: Mask.currency({
            value: faturamin,
            lang: "pt-br",
            currency: 'BRL',
            style: 'currency'
          }),
        };
        setCurrentPlan(resultItem);
        console.log("Plano final: ", resultItem)
      });
    };

  };

  const handleSubmit = (values) => {
    loading.start();
    let paymentQst = [];

    Object.keys(values).forEach((idQuestion) => {
      const item = questions.find(element => element.idQuestion.toString() === idQuestion);

      if (item.idQuestionnaire !== 27) {
        return;
      };

      let qst = {
        idAnswerOption: Array.isArray(values[idQuestion])
          ? values[idQuestion].map((option) => option.idAnswerOption?.toString())
          : values[idQuestion].idAnswerOption?.toString(),
        idDomainPersonRole: item.idDomainPersonRole,
        idQuestion: Number(idQuestion),
        idQuestionnaire: item.idQuestionnaire,
        questionDomain: item.questionDomain,
        textQuestionAnswer: Array.isArray(values[idQuestion])
          ? values[idQuestion].map((answer) => answer.answerOptionDescription)
          : values[idQuestion].dsAnswerOption
            ? values[idQuestion].dsAnswerOption
            : values[idQuestion].answerOptionDescription
              ? values[idQuestion].answerOptionDescription
              : values[idQuestion],
      };

      if (item.idQuestionnaire == 27) {
        // payment questionnarie
        if (item.idQuestion == fieldQuestions.paymentDate) {
          qst.textQuestionAnswer = stringToDate(qst.textQuestionAnswer);
        }
        paymentQst.push(qst);
      }
    });

    console.log("payment array", paymentQst);
    operationContext.add2_request.formPaymentQuestionnaire = paymentQst;
    localStorage.setItem("fitOperation", JSON.stringify(operationContext));

    // Body Issue
    const issueBody = {
      coverageList: currentPlan.coverages,
      coverageListSelected: null,
      firstInstallmentDate: stringToDate(values[fieldQuestions.paymentDate]),//
      idPlanCoverage: null,
      //id_personInsured: personRole.find(item => item.idPersonRole === 4).idPerson,
      id_product: currentPlan.id_Product,
      id_product_list: [],
      idProductPlan: currentPlan.idProductPlan,
      idquoteop: idOperation,
      paymentMode: values[fieldQuestions.paymentMth].dsAnswerOption,
      premium: Mask.numbers(currentPlan.faturamin), //
      selectedLim: null,
      planOption: currentPlan.productPlanName,//
      adress: null,
      email: values[fieldQuestions.email],
      cpfOrCnpj: Mask.cpfCnpj(values[fieldQuestions.CPF]),
      proponent: values[fieldQuestions.name],//nome do cidadão
      effectiveDate: new Date(),//
      retroactivity: null,
      revenue_annual: null,
      deductible: null,
      installment_number: null,
      payment: paymentQst,
      persons: operationContext.add2_request.personQuestionnaire
    };

    // Submetendo questionario de Payment
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestAddAction4(paymentQst, idOperation)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code != 200) {
          mc.error(`${response.ret_msg_details}`);
          loading.stop();
          return;
        }

        console.log("body Issue: ", issueBody);
        operationContext.issue_request = issueBody;
        fitinsur.requestIssueAction(issueBody)
          .then(data => data.json())
          .then(response => {
            operationContext.issue_response = response.ret_value;
            if (response[0].ret_code != 200) {
              mc.error(`${response.ret_msg_details}`);
              loading.stop();
              console.log(response.JSON.stringify());
              return;
            }
            mc.success(`Seguro enviado com sucesso`);
            loading.stop();
            history.push(`/embed/page12/${idOperation}`);
          })
      })
      .cath(error => {
        loading.stop();
        console.error(error);
      });

  };

  const stringToDate = (string) => {
    console.log('data', string);
    let parts = string.split('/');
    let date = new Date(`${parts[1]}/${parts[0]}/${parts[2]}`);
    console.log('data formatada', date);
    return date;
  }

  const createValidation = () => {
    return yup.object().shape({
      /*  192: yup.string().notRequired(),
       197: yup.string().notRequired(), */
      "235": yup.boolean().oneOf([true], "* Campo obrigatório"),
      "192": fitform.verifyRequired(fieldQuestions.Pep, questions)
        ? yup.string().required("* Campo obrigatório")
        : yup.string().notRequired(),
      "197": fitform.verifyRequired(fieldQuestions.paymentMth, questions)
        ? yup.string().required("* Campo obrigatório")
        : yup.string().notRequired(),
      "198": fitform.verifyRequired(fieldQuestions.paymentDate, questions)
        ? yup.string().required("* Campo obrigatório")
        : yup.string().notRequired(),
    });
  };

  useEffect(() => {
    //loading.start();


    async function loadContent() {
      await getInitialValues();
    }
    loadContent();
    //loading.stop();
  }, [])


  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={initial}
        onSubmit={(values) => handleSubmit(values)}
        validationSchema={createValidation()}
      >
        {({ values, setFieldValue, errors, touched }) => (
          <Form>
            <Row style={{ textAlign: "center", justifyContent: "center" }}>
              {messageHeader()}
            </Row>
            <Row><hr style={{ width: "100%", boxShadow: "rgba(0, 0, 0, 0.05) 1px 3px 5px 1px", margin: "0px 0px 8px 0px" }} /></Row>

            <Row>
              <div style={{ width: "90%", marginLeft: "5%", marginRight: "5%", boxShadow: "0px 5px 10px 8px rgba(238,240,253)" }}>
                <Row style={{ justifyContent: "space-between", margin: "1%" }}>
                </Row>
                <Row>
                  <Col>
                    <Field
                      name={fieldQuestions.name}
                      label={fitform.getDsQuestion(fieldQuestions.name, questions)}
                      component={fitform.verifyComponent(fieldQuestions.name, questions)}
                      options={fitform.verifyOptions(fieldQuestions.name, questions)}
                      disabled={true}
                      readOnly
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      name={fieldQuestions.CPF}
                      label={fitform.getDsQuestion(fieldQuestions.CPF, questions)}
                      component={fitform.verifyComponent(fieldQuestions.CPF, questions)}
                      options={fitform.verifyOptions(fieldQuestions.CPF, questions)}
                      disabled
                      readOnly
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6} sm={6} xs={6}>
                    <Field
                      name={fieldQuestions.mntContribution}
                      label={fitform.getDsQuestion(fieldQuestions.mntContribution, questions)}
                      component={fitform.verifyComponent(fieldQuestions.mntContribution, questions)}
                      options={fitform.verifyOptions(fieldQuestions.mntContribution, questions)}
                      disabled
                      readOnly
                    />
                  </Col>
                  <Col md={6} sm={6} xs={6}>
                    <Field
                      name={fieldQuestions.paymentMth}
                      label={fitform.getDsQuestion(fieldQuestions.paymentMth, questions)}
                      options={fitform.verifyOptions(fieldQuestions.paymentMth, questions)}
                      component={fitform.verifyComponent(fieldQuestions.paymentMth, questions)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      name={fieldQuestions.Pep}
                      label={fitform.getDsQuestion(fieldQuestions.Pep, questions)}
                      component={fitform.verifyComponent(fieldQuestions.Pep, questions)}
                      options={fitform.verifyOptions(fieldQuestions.Pep, questions)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      name={fieldQuestions.paymentDate}
                      label={fitform.getDsQuestion(fieldQuestions.paymentDate, questions)}
                      component={fitform.verifyComponent(fieldQuestions.paymentDate, questions)}
                      onChange={(value) => { setFieldValue(fieldQuestions.paymentDate, Mask.date(value)) }}
                    //type="number"
                    />
                  </Col>
                </Row>
                <Row>

                  <Col >
                    <p style={{ margin: "0px", fontSize: "x-small" }}>{fitform.getDsQuestion(fieldQuestions.authorizeCharge, questions)}</p>
                    {errors[fieldQuestions.authorizeCharge] && touched[fieldQuestions.authorizeCharge] ? <ErrorMessage>{errors[fieldQuestions.authorizeCharge]}</ErrorMessage> : ""}
                  </Col>
                  <Col style={{ maxWidth: "min-content" }}>
                    <BorderSwitch>
                      <Switch
                        height={27}
                        width={53}
                        checked={values[`${fieldQuestions.authorizeCharge}`]}
                        onChange={(a) => { setFieldValue(fieldQuestions.authorizeCharge, a) }}
                        checkedIcon={false}
                        uncheckedIcon={false}
                        handleDiameter={20}
                        offColor={Colors.WHITE}
                        onColor={Colors.GREEN}
                        offHandleColor={Colors.GREEN}
                        onHandleColor={Colors.WHITE}
                      />
                    </BorderSwitch>
                  </Col>
                </Row>
              </div>
            </Row>


            <ButtonContainer style={{ justifyContent: "center" }}>
              <ButtonContent>

                <ButtonMiradorOrange
                  style={{ whiteSpace: "break-spaces", textTransform: "none", margin: "0% 5%" }}
                  type="submit"
                  primary
                  id="btnSubmit"
                  disabled={false}
                >Confirmo a aquisição do plano MIRADOR família
                </ButtonMiradorOrange>
              </ButtonContent>
            </ButtonContainer>
            <Row style={{ placeContent: "center", margin: "20px" }}>
              <ButtonMiradorWhite
                onClick={() => history.push(`/embed/page7/${idOperation}`)}
              > <p style={{ margin: "0px" }}> Ops! Estou com dúvidas, <br /> preciso de ajuda para concluir </p>
              </ButtonMiradorWhite>
            </Row>
            <Row><br /></Row>
          </Form>
        )}
      </Formik>
      {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
    </>
  )
}